import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=15d103fc&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d103fc')) {
      api.createRecord('15d103fc', component.options)
    } else {
      api.reload('15d103fc', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=15d103fc&", function () {
      api.rerender('15d103fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21QE22aZ8kDkx/JS/comp/ImgFallback.vue"
export default component.exports